<!-- 
  ===============================================================================
  Using this component to displaying salesforce grant flows required fields in configuration form.
  Grant flows:
  1. Username-password flow
  2. OAuth2.0 JWT Bearer flow
  ===============================================================================
-->
<template>
  <v-row>   
    <!-- GrantType select box -->
    <v-col cols="12">
      <v-autocomplete
      :label="$t('customer.linkTranscript.salesforce.grantType')"
      v-model="grantType"
      :items="grantTypes"
      tabindex="6"
      ></v-autocomplete>
    </v-col> 
    <!-- Default Grant type values as per salesforce -->
    <v-col cols="12">
      <v-text-field 
        :label="$t('customer.linkTranscript.salesforce.grantInfo.grant_type')" 
        type="text"
        v-model="selectedGrantInfo.grant_type"
        required
        readonly
        dense
      ></v-text-field>
    </v-col>  
    <!-- Username text-field -->
    <v-col cols="12">
      <v-text-field 
        :label="$t('customer.linkTranscript.salesforce.grantInfo.username')" 
        type="text"
        v-model="username"
        required
        dense
        v-on:keyup="emitToParent"
        tabindex="7"
      ></v-text-field>
    </v-col> 
    <!-- Password text-field -->
    <v-col v-if="selectedGrantInfo.grant_type === 'password'" cols="12">
      <v-text-field 
        :label="$t('customer.linkTranscript.salesforce.grantInfo.password')" 
        :type="showPassword ? 'text' : 'password'"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        v-model="password"
        @click:append="showPassword = !showPassword"
        required
        dense
        v-on:keyup="emitToParent"
        tabindex="8"
      ></v-text-field>
    </v-col>
    <!-- Digital certificate download icon along with info -->
    <v-row v-if="downloadSFCertificateFile === true" cols="12">
      <v-col cols="12" md="9" class="py-0" tabindex="9">
        <p class="font-weight-medium text-left">{{ $t('customer.linkTranscript.salesforce.digitalCertificateMsg') }}</p>
      </v-col>
      <v-col cols="12" md="3" tabindex="10">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              @click="downloadSFCertificate"
              right
              large
              color="primary"
            >
              <v-icon dark>mdi-outlined mdi-download</v-icon> 
            </v-btn>
          </template>
          <span>
            {{ $t('customer.linkTranscript.salesforce.downloadMsg') }}
          </span>
        </v-tooltip>    
      </v-col>
    </v-row>                
  </v-row>
</template>

<script>
  /** 
   @desc Importing required modules 
  */
  import { salesforceAccountMixin } from '../mixins/salesforceAccountMixins'

  export default {
    created() {
      // If sfServerAuth exists in crmconfig 
      if(this.configuration.sfServerAuth) {
        this.grantInfoExisted = true;
        this.existedGrantInfo = this.selectedGrantInfo =  this.configuration.sfServerAuth;
        // Grant Types selectbox value
        this.grantType = (this.selectedGrantInfo.grant_type === 'password') ? 'Password' : 'JWT Bearer';
      }
      // If sfServerAuth not exists in crmconfig 
      else {
        // Grant Types selectbox default value
        this.selectedGrantInfo = this.grantInfo['Password'];
        this.grantType = 'Password';
      }
    },
    data () {
      return {
        username: '', // Username text-field binding value
        password: '',  // Username text-field binding value
        grantInfoExisted: false, // selected config grant info status
        existedGrantInfo: {}  // selected config grant details
      }
    },
    props: [
      'configuration' // Slected crm configuration from parent component
    ],
    methods: {
      /**
        * @desc Define the method that emits data to the parent
        * @param object event: Contains text-field value information  
      */
      emitToParent (event) {
        // Grant fields username and password real-time values
        this.selectedGrantInfo.username = this.username;
        if (this.selectedGrantInfo.grant_type === 'password') {
          this.selectedGrantInfo.password = this.password;
        }
        // The first parameter is function referenced in the parent componentsalesforceConfiguration.vue. 
        // The second parameter is the payload.
        this.$emit('childToParent', this.selectedGrantInfo);        
      }
    },
    mixins: [salesforceAccountMixin],
    watch: {
      /**
        * @desc Observing grant type field
        * @param string newVal: Contains user selected grant flow name
      */
      grantType: function (newVal) {  
        const grantCommand = this.grantInfo[newVal].grant_type;

        if(this.grantInfoExisted && this.existedGrantInfo.grant_type === grantCommand ) {
          this.selectedGrantInfo = this.existedGrantInfo;
        } else {
          this.selectedGrantInfo = this.grantInfo[newVal];
        }
        // Grant fields username and password values
        this.username = this.selectedGrantInfo.username;
        if (this.selectedGrantInfo.grant_type === 'password') {
          this.password = this.selectedGrantInfo.password;
        }
        this.$emit('childToParent', this.selectedGrantInfo);
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>